module.exports = __webpack_public_path__ + "img/chat_bg_2.6951952b.jpg";